import axios from 'axios';
import {UNAUTHORIZED} from 'http-status-codes';
import {check, getAuthorizationToken} from './utils/tokenUtils';
import AuthorizationHandler from './authorizationHandler';
import store, {history} from './store';

const BASE_URL = '/';

const token = getAuthorizationToken();

if (token && check()) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}

const irelandApi = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
  }
});

const handleResponse = response => response;

const handleError = (error) => {
  const {status} = error.response;
  const {pathname: path} = window.location;
  const {dispatch} = store;

  const authHandler = new AuthorizationHandler(path);

  if ((status === UNAUTHORIZED || !getAuthorizationToken()) && !authHandler.skipsAuthorize()) {
    authHandler.resolveError()(dispatch, history);
  }

  return Promise.reject(error);
};

irelandApi.interceptors.response.use(handleResponse, handleError);

// eslint-disable-next-line no-unused-vars
irelandApi.mock = (url, payLoad = null, time = 1000) => new Promise(resolve => setTimeout(resolve, time));

export default irelandApi;



// WEBPACK FOOTER //
// ./src/irelandApi.js